// extracted by mini-css-extract-plugin
module.exports = {"inputFields":"Template_inputFields__22B04"};